import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap/lib';

export default class CompetitiveSetSelect extends Component {
  static propTypes = {
    row: PropTypes.object,
    actions: PropTypes.func,
    jobId: PropTypes.number,
    competitiveSetItems: PropTypes.array,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    disabled: false
  };

  handleSelect(row, idx) {
    const { competitiveSetItems } = this.props;

    if (competitiveSetItems && competitiveSetItems.length > 0) {
      const compSetPK = competitiveSetItems[idx - 1] && competitiveSetItems[idx - 1].competitive_set_pk;

      if (row) {
        if (compSetPK === row.competitive_set_pk || (!idx && !row.competitive_set_pk)) return;
      }

      this.props.actions('assignCompetitiveSet', {
        competitive_set_pk: compSetPK,
        org_job_id: this.props.jobId
      });
    }
  }

  render() {
    const { row, competitiveSetItems, disabled } = this.props;

    const greenCheck = <i className="icon-check" aria-hidden="true" />;

    const selectedCompSet =
      competitiveSetItems && competitiveSetItems.length > 0 && row
        ? competitiveSetItems.find(set => set.competitive_set_pk === row.competitive_set_pk)
        : undefined;

    const compSetName = selectedCompSet ? selectedCompSet.competitive_set_name : 'None ';

    return (
      <div className="survey__dropdowns compsets__dropdown">
        <div className="dropdown__btn--label">Competitive Set: </div>
        {competitiveSetItems && competitiveSetItems.length > 0 ? (
          <DropdownButton
            title={compSetName}
            className="compsets__dropdown-btn"
            onSelect={this.handleSelect.bind(this, row)}
            id="competitive-set-select-dropdown"
            disabled={disabled}
          >
            {[
              {
                competitive_set_pk: null,
                competitive_set_name: 'None'
              }
            ]
              .concat(competitiveSetItems)
              .map((compSet, index) => {
                return (
                  <MenuItem eventKey={index} key={compSet.competitive_set_pk}>
                    {row && compSet.competitive_set_pk === row.competitive_set_pk ? greenCheck : ''}
                    {compSet.competitive_set_name}
                  </MenuItem>
                );
              })}
          </DropdownButton>
        ) : (
          <span className="no-item__dropdown--label">None</span>
        )}
      </div>
    );
  }
}
